import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
    selector: 'app-private',
    templateUrl: './private.component.html',
    styleUrls: ['./private.component.css'],
    standalone: false
})
export class PrivateComponent implements OnInit {
  route: string;
  currentTab = null;
  headerShow = true;
  footerShow = true;
  constructor(location: Location, private router: Router) {
   
  }


  ngOnInit() {
    if (this.router.url.includes('/profile/reset-password')){
      this.footerShow = false;
    }
    else{
      this.footerShow = true;
    }
  }

}
